import { Button, Form } from 'antd';
import { OpenWebLoginButtons } from 'client/components/auth/login/open-web/OpenWebLoginButtons';
import { resolvePublicPath } from 'client/core/appConfig';
import { CheckboxInputItem } from 'client/ui/form/input/CheckboxInputItem';
import { ICitizenRegisterDto } from 'common/dto/CitizenDto';
import { CitizenNationality } from 'common/schema/Citizen';
import { useFormikContext } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserAccountForm } from './UserAccountForm';
import { UserProfileFieldsForm } from './UserProfileFieldsForm';
import { UserNationalityForm } from './UserNationalityForm';
import { FormItemLayout } from 'client/ui/form/FormItem';

interface IUserRegistrationFormProps {
  layout: FormItemLayout;
  tailLayout: FormItemLayout;
}

/** Form registrazione utente */
export function UserRegistrationForm(props: IUserRegistrationFormProps) {
  const { layout, tailLayout } = props;
  const formik = useFormikContext<ICitizenRegisterDto>();
  const { t } = useTranslation();

  return (
    <>
      <UserNationalityForm layout={layout} />
      {(formik.values.nationality === CitizenNationality.Italy ||
        formik.values.nationality === CitizenNationality.EU) && (
        <OpenWebLoginButtons />
      )}
      {formik.values.nationality === CitizenNationality.ExtraEU && (
        <>
          {/* Form Utente */}
          <UserAccountForm layout={layout} />

          {/* Anagrafica cittadino */}
          <UserProfileFieldsForm />

          <CheckboxInputItem
            name="privacyAcceptance"
            label={t('user.registration.form.privacy-acceptance', 'Consenso')}
            title={
              <span>
                {t(
                  'user.registration.form.privacy-acceptance-text',
                  'Acconsento al'
                )}{' '}
                <a
                  href={`${resolvePublicPath(
                    t(
                      `mixed:user.registration.form.privacy-cookie-policy-file-name`,
                      'privacy_e_cookie_policy.pdf'
                    )
                  )}`}
                  target="_blank"
                >
                  {t(
                    'user.registration.form.privacy-acceptance-link-text',
                    'trattamento dei dati.'
                  )}
                </a>
              </span>
            }
          />
          <Form.Item {...tailLayout}>
            <Button
              loading={formik.isSubmitting}
              htmlType="submit"
              type="primary"
              style={{ width: '100%' }}
            >
              {t('user.registration.form.submit-button', 'Registrati')}
            </Button>
          </Form.Item>
        </>
      )}
    </>
  );
}
